export class Rubrica {
  constructor ({id, nome, codigo}) {
    this.id = id
    this.nome = nome
    this.codigo = codigo
  }
}
